import '../sass/project.scss';
// import Toastify from 'toastify-js';
// import toast, { Toaster } from 'solid-toast';
// import {toast} from '@brenoroosevelt/toast'
// const Toastify = require("toastify-js")
import Toastify from 'toastify-js';

(function ($) {
    "use strict";

    // Get csrftoken
    function getCookie(name) {
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }

    $(document).ready(() => {
        if ($('#partners').length) {
            $('#partners').slick({
                dots: true,
                autoplay: true,
                speed: 1500,
                arrows: false,
                autoplaySpeed: 1900,
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 5,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 1280,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            dots: false,
                            infinite: true,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            dots: false,
                            infinite: true,
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }
                ]
            });
        }

        $('#subscribe-form').submit(function (event) {
            var csrftoken = getCookie('csrftoken');
            $.ajax({
                type: 'post',
                url: $(this).attr('action'),
                data: {
                    'email': $(this).find('input[name=email]').val(),
                    'csrfmiddlewaretoken': csrftoken,
                },
                success: function (msg) {
                    $('#subscribe-form').append("<h4 class='text-center'>" + msg['msg'] + "</h4>");
                    $('#subscribe-form .remove-js').remove();
                },
            });
            return false;
        });
        
    })

}(jQuery));


/*————————————————————————————————————————————————————*\
    ●❱ Push notifications
\*————————————————————————————————————————————————————*/
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes;
}

let checkUnreadNotifications = () =>{
    let circle = document.querySelector("circle");
    let notifContainer = document.querySelector("#notifContainer");
    if (notifContainer) {
        let unreaded = notifContainer.querySelectorAll(".notification--noreaded");
    
        if (unreaded.length >0)
            {
                if (circle.classList.contains("hidden"))
                {
                    circle.classList.remove("hidden");
                }
            }  
        
        else if (unreaded.length === 0){
            circle.classList.add("hidden")
        }
    }
} 

checkUnreadNotifications();

let createToast = data =>{
    let getCSRFToken = document.getElementsByName("csrfmiddlewaretoken")[0].value;
    let notificationUrl = data.notification.url


    Toastify({
        text: ` ${data.notification.body}`,
        duration: 10000,
        // destination: `${window.location.origin}${data.notification.url}`,
        newWindow: false,
        close: true,
        gravity: "bottom", 
        position: "left", 
        stopOnFocus: true, 
        offset: {
            x: 50, 
            y: -100 
          },
        style: {
          background: "rgb(2,0,36)",
          background: "linear-gradient(172deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 7%, rgba(180,237,249,1) 100%)"
        },
        onClick: function(){
            fetch('/comment/api/mark-notifications-as-read/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCSRFToken,
                },
                body: JSON.stringify({id: data.notification.id, type: "notification_comment" })
            })
            .then(response => response.json())
            .then(data => {
                if (data.status ==="success") {
                    window.location.href = `${window.location.origin}${notificationUrl}`;
                }


                else{
                    alert('Error marking notification as read. Let us check and refresh page');
                }
            })


        }
      
      }).showToast();


}

const notificationSocket = new WebSocket(
    (window.location.protocol === 'https:' ? 'wss://' : 'ws://') + window.location.host + '/ws/notification/'
);


notificationSocket.onerror = function(error) {
    console.log('WebSocket Error:', error);
};

notificationSocket.onmessage = function(e) {
    const data = JSON.parse(e.data);
    const notificationContainer = document.querySelector("#notifContainer")
    let circle = document.querySelector("circle")
    

    if (notificationContainer)        
    {
        const notificationIcon = document.querySelector("#notificationIcon");
        if (circle.classList.contains("hidden"))
        {
            circle.classList.remove("hidden");
        }

        notificationIcon.classList.add("iconRotate");
        setTimeout(() => {
            notificationIcon.classList.remove("iconRotate");
        }, 30000);

        
        let notificationElement = `
        <button data-slug="${data.notification.url}" class="withOpacity notification--noreaded  notification__object notification__object_mark_as_read p-3 text-gray-400 mr-4 text-start z-50" data-notification-id="${data.notification.id}" data-notification-type="notification_comment">
        

          <div class="flex justify-between mb-2 ">
            <span class="w-2 h-2  bg-blue-noti  rounded-full"></span>
            <div class="menu-container">
              <div class="icon-dots">
                  <span>•••</span>
              </div>
              <div class="menu-options">
                <p class="mark-as-read"> Mark as read </p>
                <p class="hide-item">Hide</p>
              </div>
            </div>
          </div>
          
          <span class="block notification__title mb-1 md:text-sm lg:text-base trim_text trim_text--line-size-3 ">
            
          
          ${data.notification.body}    
          
            
          </span>
          
          <span class="notification__date my-2 md:text-sm lg:text-base">
            ${data.notification.time}
          </span>
        
        </button>
        `


        notificationContainer.insertAdjacentHTML("afterbegin", notificationElement)

        const newNotification = notificationContainer.firstElementChild;
    setTimeout(() => {

        newNotification.style.animationName =  "hide";
        newNotification.style.animationDuration = "2s";
        newNotification.style.animationFillMode = "forwards";
        newNotification.style.opacity = 1;
        newNotification.style.transform = 'translateY(0)';
    }, 1000);

    }
    
    createToast(data);

    
};

self.addEventListener('push', function(event) {
    const data = event.data.json();
    const options = {
        body: data.body,
        icon: '/static/images/icons/notifications-icons.svg',
    };
    event.waitUntil(
        self.registration.showNotification(data.title, options)
    );
});


function getCSRFToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}


const header = document.getElementById("Header");
if (header) {
    const nav_1 = document.getElementById("nav_1");
    const white_logo = document.querySelector('#logo_blanco');
    const header_height = header.offsetHeight;

    window.addEventListener('scroll', function () {
        const scrollpos = window.scrollY;
        if (scrollpos >= header_height) {
            header.classList.add("bg-gray-900");
            nav_1.classList.add("hidden");
            white_logo.classList.remove("hidden");
        } else {
            header.classList.remove("bg-gray-900");
            nav_1.classList.remove("hidden");
            white_logo.classList.add("hidden");
        }
    });
}

/*————————————————————————————————————————————————————*\
    ●❱ ANIMATIONS
\*————————————————————————————————————————————————————*/

let slideUp = (target, duration = 500) => {
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.boxSizing = "border-box";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
        target.style.display = "none";
        target.style.removeProperty("height");
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
        //alert("!");
    }, duration);
};
let slideDown = (target, duration = 500) => {
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;

    if (display === "none") display = "flex";

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = "border-box";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(() => {
        target.style.removeProperty("height");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
    }, duration);
};
let slideToggle = (target, duration = 500) => {
    if (window.getComputedStyle(target).display === "none") {
        return slideDown(target, duration);
    } else {
        return slideUp(target, duration);
    }
};

function toggle_attr_expand(element) {

    if (element.getAttribute("aria-expanded") === "true") {
        element.setAttribute("aria-expanded", "false");
    } else {
        element.setAttribute("aria-expanded", "true");
    }
}

/*————————————————————————————————————————————————————*\
    ●❱ Sub menu
\*————————————————————————————————————————————————————*/
const submenu = document.querySelectorAll('#submenu');
const hambuger = document.querySelector('.hamburger');
let display_hamburger = '';

if (hambuger) {
    window.addEventListener("resize", function(){
        display_hamburger = window.getComputedStyle(hambuger, null).display;
    });
}

if(submenu) {
    submenu.forEach((e, i) => {
        submenu[i].addEventListener('click', () => {
            slideToggle(submenu[i].nextElementSibling);
            toggle_attr_expand(submenu[i]);
            if (display_hamburger != 'flex') {
                submenu.forEach((e, j) => {
                    if (i != j){
                        submenu[j].nextElementSibling.style.display="none";
                    }
                });
            }
            submenu[i].lastElementChild.classList.toggle('active');
        });
    });
}

const menu_vertical = document.querySelector('#checkbox');
const menu_list = document.querySelector('.menu__list');
if (menu_vertical || menu_list) {
    menu_vertical.addEventListener('change', () => {
        if (menu_vertical.checked)
            menu_list.classList.add('menu_active');
        else
            menu_list.classList.remove('menu_active');
    });
}


/*————————————————————————————————————————————————————*\
    ●❱ Filters
\*————————————————————————————————————————————————————*/
const btn_filters = document.querySelectorAll('#btn_group_filter');
if (btn_filters) {
    btn_filters.forEach((e, i) => {
        btn_filters[i].addEventListener('click', () => {
            slideToggle(btn_filters[i].nextElementSibling);
            toggle_attr_expand(btn_filters[i]);
            btn_filters[i].lastElementChild.classList.toggle('active');
        });
    });
}

const btn_subfilters = document.querySelectorAll('#btn_subgroup_filter');
if (btn_subfilters || btn_filters) {
    btn_subfilters.forEach((e, i) => {
        btn_subfilters[i].addEventListener('click', () => {
            if (btn_subfilters[i].nextElementSibling || btn_filters[i].lastElementChild) {
                slideToggle(btn_subfilters[i].nextElementSibling);
                toggle_attr_expand(btn_subfilters[i]);
                btn_subfilters[i].lastElementChild.classList.toggle('active');
            }
        });
    });
}


// functions for mark as read and hide
document.addEventListener('click', function(event) {
    if (event.target.classList.contains('mark-as-read') || event.target.parentElement.classList.contains('notification__object_mark_as_read')) {
        event.preventDefault();

        let notification = event.target.closest('.notification__object');
        let point = notification.firstElementChild.firstElementChild;
        let notificationId = notification.dataset.notificationId; 
        let notificationType = notification.dataset.notificationType;
        let notificationSlug = notification.dataset.slug;
        let getCSRFToken = document.getElementsByName("csrfmiddlewaretoken")[0].value;

        fetch('/comment/api/mark-notifications-as-read/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken,
            },
            body: JSON.stringify({id: notificationId, type: notificationType })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {
                if (notification.classList.contains('notification--noreaded')) {
                    notification.classList.remove('notification--noreaded');
                    notification.classList.add('notification--readed');
                    point.classList.remove('bg-blue-noti');
                    point.classList.add('bg-gray-noti');
                    notification.querySelector('.mark-as-read').textContent = 'Mark as unread'
                } /*else {
                    notification.classList.remove('notification--readed');
                    notification.classList.add('notification--noreaded');
                    notification.querySelector('.mark-as-read').textContent = 'Mark as read'
                    point.classList.add('bg-blue-noti');
                    point.classList.remove('bg-gray-noti');
                }*/

                checkUnreadNotifications();
                
                if (event.target.parentElement.classList.contains('notification__object_mark_as_read')) {
                    window.location.href = notificationSlug;
                }
            } else {
                alert('Error marking notification as read. Let us check and refresh page');
            }
        });
    }

    if (event.target.classList.contains('hide-item')) {
        event.preventDefault();
        let notification = event.target.closest('.notification__object');
        let notificationId = notification.dataset.notificationId;
        let notificationType = notification.dataset.notificationType; 
        let getCSRFToken = document.getElementsByName("csrfmiddlewaretoken")[0].value; 

        fetch('/comment/api/mark-notifications-hide/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': getCSRFToken,
            },
            body: JSON.stringify({ id: notificationId, type: notificationType })
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {
                notification.closest('button, div').remove();
                checkUnreadNotifications();
            } else {
                alert('Error hiding notification.Let us check and refresh page');
            }
        });


        
    }

    


    // Checks if there is a notification unreaded and adds the circle
    

});
